import "../Css/CvHeader.css";
import { useState } from "react";
import { Container, Modal } from "react-bootstrap";
import { ReactComponent as LinkedInIcon } from "../Assets/Icons/linkedin.svg";
import { ReactComponent as EmailIcon } from "../Assets/Icons/email.svg";
import { ReactComponent as WebpageIcon } from "../Assets/Icons/webpage-icon.svg";
// import { ReactComponent as DownloadPdfIcon } from "../Assets/Icons/download-pdf.svg";
import profileImg from "../Assets/Images/profile.jpg";

const CvHeader = () => {

    const [showModal, setShowModal] = useState(false);

    // const handleDownloadPdfClick = () => {};

    return (

        <header className="header" id="header">

            <Container>

                <div className="header-content">

                    <img
                        src={profileImg}
                        alt="Profile"
                        className="profile-pic"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowModal(true)}
                    />

                    <div className="header-text">

                        <h1>Papadopoulos Eleftherios</h1>

                        <p className="header-role">Product Engineer | MSc in AI</p>

                        <p className="header-location"><i className="fas fa-location-dot"></i> Thessaloniki, Greece</p>

                        <div className="social-icons">

                            <a href="https://www.linkedin.com/in/eleftheriosvpapadopoulos" title="https://www.linkedin.com/in/eleftheriosvpapadopoulos" target="_blank" rel="noopener noreferrer">
                                <LinkedInIcon className="linkedin-btn" />
                            </a>

                            <a href="mailto:eleftherios.v.papadopoulos@gmail.com" title="mailto:eleftherios.v.papadopoulos@gmail.com">
                                <EmailIcon className="email-btn" />
                            </a>

                            {
                                window.location.href !== "https://cv.planwise.site/"
                                &&
                                <a href="https://cv.planwise.site/" title="https://cv.planwise.site/">
                                    <WebpageIcon className="webpage-btn" />
                                </a>
                            }

                        </div>

                    </div>

                </div>

            </Container>

            {/* Modal for large image display */}

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Body className="text-center">
                    <img
                        src={profileImg}
                        alt="Profile Large"
                        className="img-fluid rounded"
                        style={{ maxWidth: "100%", maxHeight: "80vh" }}
                    />
                </Modal.Body>
            </Modal>

        </header>
    )

}

export default CvHeader;